<template>
  <div class="mid_scroll_content socialTrading">
    <loader v-show="pageLoader"></loader>
    <section v-if="taskTab == ''" class="forecastPortfolio border-0">
      <div class="row mt-md-4">
        <div class="col-12 col-lg-8">
          <div class="d-flex align-items-center flex-wrap-mobile">
            <div class="card-body">
              <p class="mb-0">Estimated</p>
              <p>Holding Value</p>
              <h3 class="secondarycolor">
                {{ formatPrice(totalBtcValue, true) }}
                <span class="f-14 textcolor">BTC</span>
              </h3>
            </div>
            <div class="card-body mx-md-4">
              <p class="mb-0">Approximate</p>
              <p>USD Value</p>
              <h3 class="secondarycolor">
                {{ formatPrice(totalUsdValue) }}
                <span class="f-14 textcolor">USD</span>
              </h3>
            </div>
          </div>

          <div class="recentTransaction blockSpace">
            <div
              class="topFilter-bar whiteBar d-flex align-items-center justify-content-between flex-wrap mb-3"
            >
              <h3 class="semibold mb-0">Recent Orders</h3>
              <ul class="nav nav-tabs noBG border-0 mobScrollable">
                <li
                  class="nav-item"
                  :class="type == '2' ? 'active' : 'deposit_bg'"
                  @click.prevent="
                    type = '2';
                    page = '1';
                  "
                >
                  <a class="nav-link" href="#">Completed</a>
                </li>
                <li
                  class="nav-item"
                  :class="type == '1' ? 'active' : 'deposit_bg'"
                  @click.prevent="
                    type = '1';
                    page = '1';
                  "
                >
                  <a class="nav-link" href="#">Open</a>
                </li>
                <li
                  class="nav-item"
                  :class="type == '3' ? 'active' : 'deposit_bg'"
                  @click.prevent="
                    type = '3';
                    page = '1';
                  "
                >
                  <a class="nav-link" href="#">Rejected </a>
                </li>
                <li
                  class="nav-item"
                  :class="[
                    type == '4' ? 'active' : 'deposit_bg',
                    { disabled: pageLoader },
                  ]"
                  @click.prevent="
                    type = '4';
                    page = '1';
                  "
                >
                  <a class="nav-link" href="#">Deposits</a>
                </li>
                <li
                  class="nav-item"
                  :class="[
                    type == '5' ? 'active' : 'deposit_bg',
                    { disabled: pageLoader },
                  ]"
                  @click.prevent="
                    type = '5';
                    page = '1';
                  "
                >
                  <a class="nav-link" href="#">Withdrawals</a>
                </li>
              </ul>
            </div>
            <div class="recentTable">
              <table
                class="table table-striped table-bordered"
                v-show="type == '2'"
              >
                <thead class="thead-white">
                  <tr>
                    <th>Action</th>
                    <th>Order Type</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody v-if="orderData('2').length > 0">
                  <tr v-for="(val, index) in orderData('2')" v-if="index < 4">
                    <td>
                      <div class="d-flex coinName">
                        <span class="flex-shrink-0">
                          <img
                            :src="
                              '../../../../static/website/images/crypto_logos/' +
                              val.Symbol.split('-')[0].toLowerCase() +
                              '.png'
                            "
                            @error="handleImgErr($event)"
                            :alt="val.Symbol.split('-')[0]"
                            v-if="
                              isImage(val.Symbol.split('-')[0].toLowerCase())
                            "
                          />
                          <span class="firstName" v-else>{{
                            val.Symbol.split("-")[0].charAt(0)
                          }}</span>
                        </span>
                        <div class="flex-grow-1 ml-3 line-1">
                          <span class="btc" v-if="val.OrderSide == 0"
                            >Sell{{
                              getCurrName(val.Symbol.split("-")[0]) ||
                              val.Symbol.split("-")[0]
                            }}</span
                          >
                          <span class="btc" v-else-if="val.OrderSide == 1"
                            >Bought{{
                              getCurrName(val.Symbol.split("-")[0]) ||
                              val.Symbol.split("-")[0]
                            }}</span
                          >
                          <span class="status complete">Completed</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span class="type yellowBG"
                        >{{ exchangeTypeS[val.OrderType]
                        }}{{
                          val.OrderSide == 0
                            ? "Sell"
                            : val.OrderSide == 1
                            ? "Buy"
                            : ""
                        }}</span
                      >
                    </td>
                    <td>
                      <span class="line-1 text-right">
                        <p class="f-16 semibold mb-0 themecolor">
                          {{ formatPrice(val.QuantityFilled, true) }}
                        </p>
                        <p class="f-14 mt-1 mb-0">{{ fromDate(val.Closed) }}</p>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" class="text-center">
                      <router-link to="/transaction-history"
                        >See All Transactions >></router-link
                      >
                    </td>
                  </tr>
                </tbody>
                <table-loader
                  :pageloader_value="pageLoader"
                  :type="'table'"
                  :colspan="'3'"
                  :listLength="orderData('2')"
                  v-else
                ></table-loader>
              </table>
              <table
                class="table table-striped table-bordered"
                v-show="type == '1'"
              >
                <thead class="thead-white">
                  <tr>
                    <th>Action</th>
                    <th>Order Type</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody v-if="orderData('1').length > 0">
                  <tr v-for="(val, index) in orderData('1')" v-if="index < 4">
                    <td>
                      <div class="d-flex coinName">
                        <span class="flex-shrink-0">
                          <img
                            :src="
                              '../../../../static/website/images/crypto_logos/' +
                              val.Symbol.split('-')[0].toLowerCase() +
                              '.png'
                            "
                            @error="handleImgErr($event)"
                            :alt="val.Symbol.split('-')[0]"
                            v-if="
                              isImage(val.Symbol.split('-')[0].toLowerCase())
                            "
                          />
                          <span class="firstName" v-else>{{
                            val.Symbol.split("-")[0].charAt(0)
                          }}</span>
                        </span>
                        <div class="flex-grow-1 ml-3 line-1">
                          <span class="btc" v-if="val.OrderSide == 0"
                            >Sell{{
                              getCurrName(val.Symbol.split("-")[0]) ||
                              val.Symbol.split("-")[0]
                            }}</span
                          >
                          <span class="btc" v-else-if="val.OrderSide == 1"
                            >Bought{{
                              getCurrName(val.Symbol.split("-")[0]) ||
                              val.Symbol.split("-")[0]
                            }}</span
                          >
                          <span class="status complete">Open</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span class="type yellowBG"
                        >{{ exchangeTypeS[val.OrderType]
                        }}{{
                          val.OrderSide == 0
                            ? "Sell"
                            : val.OrderSide == 1
                            ? "Buy"
                            : ""
                        }}</span
                      >
                    </td>
                    <td>
                      <span class="line-1 text-right">
                        <p class="f-16 semibold mb-0 themecolor">
                          {{ formatPrice(val.Quantity, true) }}
                        </p>
                        <p class="f-14 mt-1 mb-0">{{ fromDate(val.Opened) }}</p>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" class="text-center">
                      <router-link to="/transaction-history"
                        >See All Transactions >></router-link
                      >
                    </td>
                  </tr>
                </tbody>
                <table-loader
                  :pageloader_value="pageLoader"
                  :type="'table'"
                  :colspan="'3'"
                  :listLength="orderData('1')"
                  v-else
                ></table-loader>
              </table>
              <table
                class="table table-striped table-bordered"
                v-show="type == '3'"
              >
                <thead class="thead-white">
                  <tr>
                    <th>Action</th>
                    <th>Order Type</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody v-if="orderData('3').length > 0">
                  <tr v-for="(val, index) in orderData('3')" v-if="index < 4">
                    <td>
                      <div class="d-flex coinName">
                        <span class="flex-shrink-0">
                          <img
                            :src="
                              '../../../../static/website/images/crypto_logos/' +
                              val.Symbol.split('-')[0].toLowerCase() +
                              '.png'
                            "
                            @error="handleImgErr($event)"
                            :alt="val.Symbol.split('-')[0]"
                            v-if="
                              isImage(val.Symbol.split('-')[0].toLowerCase())
                            "
                          />
                          <span class="firstName" v-else>{{
                            val.Symbol.split("-")[0].charAt(0)
                          }}</span>
                        </span>
                        <div class="flex-grow-1 ml-3 line-1">
                          <span class="btc" v-if="val.OrderSide == 0"
                            >Sell{{
                              getCurrName(val.Symbol.split("-")[0]) ||
                              val.Symbol.split("-")[0]
                            }}</span
                          >
                          <span class="btc" v-else-if="val.OrderSide == 1"
                            >Bought{{
                              getCurrName(val.Symbol.split("-")[0]) ||
                              val.Symbol.split("-")[0]
                            }}</span
                          >
                          <span class="status reject">Rejected</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span class="type yellowBG"
                        >{{ exchangeTypeS[val.OrderType]
                        }}{{
                          val.OrderSide == 0
                            ? "Sell"
                            : val.OrderSide == 1
                            ? "Buy"
                            : ""
                        }}</span
                      >
                    </td>
                    <td>
                      <span class="line-1 text-right">
                        <p class="f-16 semibold mb-0 themecolor">
                          {{ formatPrice(val.Quantity, true) }}
                        </p>
                        <p class="f-14 mt-1 mb-0">{{ fromDate(val.Opened) }}</p>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" class="text-center">
                      <router-link to="/transaction-history"
                        >See All Transactions >></router-link
                      >
                    </td>
                  </tr>
                </tbody>
                <table-loader
                  :pageloader_value="pageLoader"
                  :type="'table'"
                  :colspan="'3'"
                  :listLength="orderData('3')"
                  v-else
                ></table-loader>
              </table>
              <table
                class="table table-striped table-bordered"
                v-show="type == '4'"
              >
                <thead class="thead-white">
                  <tr>
                    <th>Date</th>
                    <th>Exchange</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody
                  v-if="
                    'totalRecords' in depsitList && depsitList.totalRecords > 0
                  "
                >
                  <tr v-for="(val, index) in depsitList.records">
                    <td>{{ val.created | moment("DD-MM-YYYY, h:mm:ss a") }}</td>
                    <td>
                      {{ formatPrice(val.amount, true) }}{{ val.currency }}
                    </td>
                    <td>
                      <span
                        class="alert"
                        :class="
                          val.payment_status
                            ? depositStatus[val.payment_status].class
                            : ''
                        "
                        >{{
                          val.payment_status
                            ? depositStatus[val.payment_status].name
                            : "-"
                        }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" class="text-center">
                      <router-link to="/transaction-history"
                        >See All Transactions >></router-link
                      >
                    </td>
                  </tr>
                </tbody>
                <table-loader
                  :pageloader_value="pageLoader"
                  :type="'table'"
                  :colspan="'3'"
                  :listLength="depsitList.records"
                  v-else
                ></table-loader>
              </table>
              <table
                class="table table-striped table-bordered"
                v-show="type == '5'"
              >
                <thead class="thead-white">
                  <tr>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody
                  v-if="
                    'totalRecords' in withdrawalList &&
                    withdrawalList.totalRecords > 0
                  "
                >
                  <tr v-for="(val, index) in withdrawalList.records">
                    <td>{{ val.created | moment("DD-MM-YYYY, h:mm:ss a") }}</td>
                    <td>
                      {{ formatPrice(val.amount, true) }}{{ val.currency }}
                    </td>
                    <td>
                      <span
                        class="alert"
                        :class="
                          val.withdrawal_status
                            ? depositStatus[val.withdrawal_status].class
                            : ''
                        "
                        >{{
                          val.withdrawal_status
                            ? depositStatus[val.withdrawal_status].name
                            : "-"
                        }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" class="text-center">
                      <router-link to="/transaction-history"
                        >See All Transactions >></router-link
                      >
                    </td>
                  </tr>
                </tbody>
                <table-loader
                  :pageloader_value="pageLoader"
                  :type="'table'"
                  :colspan="'3'"
                  :listLength="withdrawalList.records"
                  v-else
                ></table-loader>
              </table>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="d-flex align-items-center justify-content-center mb-md-5">
            <a
              href="javascript:void(0)"
              @click="taskTab = 'TopUp'"
              class="cap_btn mr-2 sm-btn"
              >Deposit</a
            >
            <a
              href="javascript:void(0)"
              @click="taskTab = 'Withdraw'"
              class="cap_btn secondaryBG sm-btn"
              >Withdraw</a
            >
          </div>
          <div class="chartPortfolio mt-4">
            <h3 class="semibold mb-3">My Portfolio</h3>
            <currencyChart
              style="height: 180px"
              :currency_list="curencyUsdValList"
            />
            <div class="tradeGraph mx-0 mt-1">
              <div class="row calResHeight">
                <div
                  class="col-12 col-lg-6"
                  v-for="(item, key, index) in marginInfoListSocial"
                  v-if="index < 4"
                >
                  <div class="card-body">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div class="d-flex align-items-center">
                        <span class="flex-shrink-0 l-1">
                          <img
                            :src="
                              '../../../../static/website/images/crypto_logos/' +
                              item.currency.toLowerCase() +
                              '.png'
                            "
                            @error="handleImgErr($event)"
                            :alt="item.currency"
                            v-if="isImage(item.currency.toLowerCase())"
                          />
                          <span class="firstName" v-else>{{
                            item.currency.charAt(0)
                          }}</span>
                        </span>
                        <div class="flex-grow-1 ml-2 line-1 text-start">
                          <p class="themecolor uppercase mb-1 f-14">
                            {{ getCurrName(item.currency) }}
                          </p>
                          <p class="f-10 mb-0">{{ item.currency }}</p>
                        </div>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <h6 class="medium mt-2 themecolor mb-0">
                        {{ formatPrice(item.amount, true) || 0 }}
                      </h6>
                    </div>
                    <p class="mb-0 f-14">
                      USD Value:
                      <span v-if="item.amount && getConvertedValue(item, 'USD')"
                        >${{
                          formatPrice(
                            parseFloat(getConvertedValue(item, "USD")).toFixed(
                              3
                            )
                          )
                        }}</span
                      ><span v-else>N/A</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-right mb-0">
                  <router-link to="/wallets" class="link f-14"
                    >More Details >></router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-else class="cap_exhange_cur border-0 max-1440 pb-4">
      <div class="newAPIkey">
        <div class="internalTransfer mt-md-5">
          <div class="d-flex justify-space-between">
            <ul
              class="d-inline-flex align-items-center justify-content-center customTabs border mx-auto mt-3 mb-md-5"
            >
              <li>
                <a
                  @click.prevent="taskTab = 'TopUp'"
                  :class="taskTab == 'TopUp' ? 'cap_btn active' : 'bg-white'"
                  href="javascript:void(0)"
                  class="cap_btn border-0"
                >
                  Deposit</a
                >
              </li>
              <li>
                <a
                  @click.prevent="taskTab = 'Withdraw'"
                  :class="taskTab == 'Withdraw' ? 'cap_btn active' : 'bg-white'"
                  href="javascript:void(0)"
                  class="cap_btn border-0"
                  >Withdraw</a
                >
              </li>
            </ul>
          </div>
          <div class="tabList" v-if="taskTab == 'TopUp'">
            <div class="socialForm box-shadow max-900" v-if="step == 1">
              <h5 class="medium mb-4">
                Transfer Funds From Primary Account To Social Account
              </h5>
              <div
                v-if="accountsWithMargin.length"
                class="selectedProgress my-5"
              >
                <div
                  v-for="wallet of accountsWithMargin"
                  :key="wallet.act_account_id"
                  class="repeatBlock d-flex align-items-center justify-content-between mb-3"
                >
                  <div class="d-flex align-items-center nameICon equal">
                    <span class="cpIcon mr-2"
                      ><img
                        :src="
                          '../../../../static/website/images/crypto_logos/' +
                          wallet.currency.toLowerCase() +
                          '.png'
                        "
                    /></span>
                    <p class="themecolor medium mb-0 cpNmae">
                      {{ wallet.currency }}
                    </p>
                  </div>
                  <div
                    v-if="margin_list[wallet.act_account_id].freemargin > 0"
                    class="position-relative rangeSection"
                  >
                    <div
                      class="range-value"
                      :style="`left:${leftValComputed[wallet.currency]};`"
                    >
                      <span>{{ data_value[wallet.currency] }}%</span>
                    </div>
                    <input
                      class="progressbar"
                      type="range"
                      min="0"
                      max="100"
                      name="energy Level"
                      @change="(e) => setProgressBar(e.target.value, wallet)"
                      v-model="data_value[wallet.currency]"
                    />
                  </div>
                  <div
                    v-if="margin_list[wallet.act_account_id].freemargin > 0"
                    class="form-group indrive mb-0"
                  >
                    <input
                      type="text"
                      class="form-control small"
                      placeholder=""
                      @change="(e) => setAmount(e.target.value, wallet)"
                      v-model="amount[wallet.currency]"
                    />
                    <div class="maxVolume f-14 text-right">
                      <p class="mb-0 themecolor">
                        Max:{{
                          margin_list[wallet.act_account_id]
                            ? margin_list[wallet.act_account_id].freemargin
                            : 0
                        }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="rangeSection"
                    v-if="margin_list[wallet.act_account_id].freemargin == 0"
                  >
                    <p>No margin available</p>
                  </div>
                </div>
                <div class="agreePage my-4">
                  <label class="customCheckbox"
                    >I agree that only these funds will be used for social
                    trading <input type="checkbox" v-model="agree" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="d-flex justify-content-center py-3" v-else>
                <p>No account available for withdrawal</p>
              </div>
              <div
                class="d-flex align-items-center justify-content-between border-top pt-4 w-100 mt-4"
              >
                <a
                  href="javascript:void(0)"
                  class="cancel-btn medium mr-3 red"
                  @click="taskTab = ''"
                  >Cancel</a
                >
                <a
                  v-if="accountsWithMargin.length"
                  href="javascript:void(0)"
                  class="cap_btn"
                  @click="() => confirmStep()"
                  >Transfer Funds</a
                >
              </div>
              <div v-if="error" class="mt-1 alert alert-danger">
                {{ error }}
              </div>
            </div>
            <div class="socialForm box-shadow max-900" v-if="step == 2">
              <div class="successTransfer mb-4 text-center">
                <h5 class="semibold my-4">
                  Confirm your funds to be transferred to social trading account
                </h5>
              </div>
              <div
                class="selectedProgress d-flex flex-column align-items-center mt-5"
              >
                <div class="middleColumn w-100 justify-content-between">
                  <div
                    v-for="(value, key) in validAmounts"
                    class="repeatBlock d-flex align-items-center mb-3"
                  >
                    <div class="d-flex align-items-center nameICon equal">
                      <span class="cpIcon mr-2"
                        ><img
                          :src="
                            '../../../../static/website/images/crypto_logos/' +
                            key.toLowerCase() +
                            '.png'
                          "
                      /></span>
                      <p class="themecolor medium mb-0 cpNmae">{{ key }}</p>
                    </div>
                    <div class="progress bar">
                      <div
                        class="progress-bar themeBG"
                        role="progressbar"
                        aria-valuenow="30"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style="width: 100%"
                      >
                        <span class="sr-only">30%</span>
                      </div>
                    </div>
                    <div
                      class="sameRight d-flex align-items-center justify-content-end"
                    >
                      <div class="volume equal">
                        <p class="mb-0">{{ value }}</p>
                      </div>
                      <div class="maxVolume equal">
                        <p class="mb-0">{{ key }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="lightgrayBG grt authenticator mt-4 p-4 w-100">
                  <h3 class="border-bottom pb-3 mb-4">Validate OTP</h3>
                  <div class="form-group">
                    <p class="mb-4">
                      Please enter the one time passcode shown in the
                      <strong>Authenticator</strong> app
                    </p>
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="******"
                        name=""
                        v-model="gauth"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="d-flex align-items-center justify-content-between border-top pt-4 w-100 mt-4 steps mt-5 text-center"
              >
                <a
                  href="javascript:void(0)"
                  class="cancel-btn medium mr-3 red"
                  @click="step--"
                  >Back</a
                >
                <a
                  href="javascript:void(0)"
                  class="cap_btn min-250"
                  @click="() => confirmStep()"
                  >Confirm Transfer</a
                >
              </div>
              <div v-if="error" class="mt-1 alert alert-danger">
                {{ error }}
              </div>
            </div>
            <div class="socialForm box-shadow max-900" v-if="step == 3">
              <div class="successTransfer mb-4 text-center">
                <img
                  src="../../../../static/website/images/successRotate.svg"
                />
                <h5 class="semibold my-4">
                  Your funds have been transferred successfully
                </h5>
              </div>
              <div
                class="selectedProgress d-flex flex-column align-items-center mt-5"
              >
                <div class="middleColumn w-100 justify-content-between">
                  <div
                    v-for="(value, key) in validAmounts"
                    class="repeatBlock d-flex align-items-center mb-3"
                  >
                    <div class="d-flex align-items-center nameICon equal">
                      <span class="cpIcon mr-2"
                        ><img
                          :src="
                            '../../../../static/website/images/crypto_logos/' +
                            key.toLowerCase() +
                            '.png'
                          "
                      /></span>
                      <p class="themecolor medium mb-0 cpNmae">{{ key }}</p>
                    </div>
                    <div class="progress bar">
                      <div
                        class="progress-bar themeBG"
                        role="progressbar"
                        aria-valuenow="30"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style="width: 100%"
                      >
                        <span class="sr-only">30%</span>
                      </div>
                    </div>
                    <div
                      class="sameRight d-flex align-items-center justify-content-end"
                    >
                      <div class="volume equal">
                        <p class="mb-0">{{ value }}</p>
                      </div>
                      <div class="maxVolume equal">
                        <p class="mb-0">{{ key }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="steps mt-5 text-center">
                <a
                  href="javascript:void(0)"
                  class="cap_btn min-250"
                  @click="taskTab = ''"
                  >Done</a
                >
              </div>
            </div>
          </div>
          <div class="tabList" v-if="taskTab == 'Withdraw'">
            <div class="socialForm box-shadow max-900" v-if="step == 1">
              <h5 class="medium mb-4">
                Transfer Funds From Social Account To Primary Account
              </h5>
              <div
                v-if="accountsWithMargin.length"
                class="selectedProgress my-5"
              >
                <div
                  v-for="wallet of accountsWithMargin"
                  :key="wallet.act_account_id"
                  class="repeatBlock d-flex align-items-center justify-content-between mb-3"
                >
                  <div class="d-flex align-items-center nameICon equal">
                    <span class="cpIcon mr-2"
                      ><img
                        :src="
                          '../../../../static/website/images/crypto_logos/' +
                          wallet.currency.toLowerCase() +
                          '.png'
                        "
                    /></span>
                    <p class="themecolor medium mb-0 cpNmae">
                      {{ wallet.currency }}
                    </p>
                  </div>
                  <div
                    v-if="margin_list[wallet.act_account_id].freemargin > 0"
                    class="position-relative rangeSection"
                  >
                    <div
                      class="range-value"
                      :style="`left:${leftValComputed[wallet.currency]};`"
                    >
                      <span>{{ data_value[wallet.currency] }}%</span>
                    </div>
                    <input
                      class="progressbar"
                      type="range"
                      min="0"
                      max="100"
                      name="energy Level"
                      @change="(e) => setProgressBar(e.target.value, wallet)"
                      v-model="data_value[wallet.currency]"
                    />
                  </div>
                  <div
                    v-if="margin_list[wallet.act_account_id].freemargin > 0"
                    class="form-group indrive mb-0"
                  >
                    <input
                      type="text"
                      class="form-control small"
                      placeholder=""
                      @change="(e) => setAmount(e.target.value, wallet)"
                      v-model="amount[wallet.currency]"
                    />
                    <div class="maxVolume f-14 text-right">
                      <p class="mb-0 themecolor">
                        Max:{{
                          margin_list[wallet.act_account_id]
                            ? margin_list[wallet.act_account_id].freemargin
                            : 0
                        }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="rangeSection"
                    v-if="margin_list[wallet.act_account_id].freemargin == 0"
                  >
                    <p>No margin available</p>
                  </div>
                </div>
                <div class="agreePage my-4">
                  <label class="customCheckbox"
                    >I agree that only these funds will be used for social
                    trading <input type="checkbox" v-model="agree" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="d-flex justify-content-center py-3" v-else>
                <p>No account available for withdrawal</p>
              </div>
              <div
                class="d-flex align-items-center justify-content-between border-top pt-4 w-100 mt-4"
              >
                <a
                  href="javascript:void(0)"
                  class="cancel-btn medium mr-3 red"
                  @click="taskTab = ''"
                  >Cancel</a
                >
                <a
                  v-if="accountsWithMargin.length"
                  href="javascript:void(0)"
                  class="cap_btn"
                  @click="() => confirmStep()"
                  >Transfer Funds</a
                >
              </div>
              <div v-if="error" class="mt-1 alert alert-danger">
                {{ error }}
              </div>
            </div>
            <div class="socialForm box-shadow max-900" v-if="step == 2">
              <div class="successTransfer mb-4 text-center">
                <h5 class="semibold my-4">
                  Confirm your funds to be transferred to primary trading
                  account
                </h5>
              </div>
              <div
                class="selectedProgress d-flex flex-column align-items-center mt-5"
              >
                <div class="middleColumn w-100 justify-content-between">
                  <div
                    v-for="(value, key) in validAmounts"
                    class="repeatBlock d-flex align-items-center mb-3"
                  >
                    <div class="d-flex align-items-center nameICon equal">
                      <span class="cpIcon mr-2"
                        ><img
                          :src="
                            '../../../../static/website/images/crypto_logos/' +
                            key.toLowerCase() +
                            '.png'
                          "
                      /></span>
                      <p class="themecolor medium mb-0 cpNmae">{{ key }}</p>
                    </div>
                    <div class="progress bar">
                      <div
                        class="progress-bar themeBG"
                        role="progressbar"
                        aria-valuenow="30"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style="width: 100%"
                      >
                        <span class="sr-only">30%</span>
                      </div>
                    </div>
                    <div
                      class="sameRight d-flex align-items-center justify-content-end"
                    >
                      <div class="volume equal">
                        <p class="mb-0">{{ value }}</p>
                      </div>
                      <div class="maxVolume equal">
                        <p class="mb-0">{{ key }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="lightgrayBG grt authenticator mt-4 p-4 w-100">
                  <h3 class="border-bottom pb-3 mb-4">Validate OTP</h3>
                  <div class="form-group">
                    <p class="mb-4">
                      Please enter the one time passcode shown in the
                      <strong>Authenticator</strong> app
                    </p>
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="******"
                        name=""
                        v-model="gauth"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="d-flex align-items-center justify-content-between border-top pt-4 w-100 mt-4 steps mt-5 text-center"
              >
                <a
                  href="javascript:void(0)"
                  class="cancel-btn medium mr-3 red"
                  @click="step--"
                  >Back</a
                >
                <a
                  href="javascript:void(0)"
                  class="cap_btn min-250"
                  @click="() => confirmStep()"
                  >Confirm Transfer</a
                >
              </div>
              <div v-if="error" class="mt-1 alert alert-danger">
                {{ error }}
              </div>
            </div>
            <div class="socialForm box-shadow max-900" v-if="step == 3">
              <div class="successTransfer mb-4 text-center">
                <img
                  src="../../../../static/website/images/successRotate.svg"
                />
                <h5 class="semibold my-4">
                  Your funds have been transferred successfully
                </h5>
              </div>
              <div
                class="selectedProgress d-flex flex-column align-items-center mt-5"
              >
                <div class="middleColumn w-100 justify-content-between">
                  <div
                    v-for="(value, key) in validAmounts"
                    class="repeatBlock d-flex align-items-center mb-3"
                  >
                    <div class="d-flex align-items-center nameICon equal">
                      <span class="cpIcon mr-2"
                        ><img
                          :src="
                            '../../../../static/website/images/crypto_logos/' +
                            key.toLowerCase() +
                            '.png'
                          "
                      /></span>
                      <p class="themecolor medium mb-0 cpNmae">{{ key }}</p>
                    </div>
                    <div class="progress bar">
                      <div
                        class="progress-bar themeBG"
                        role="progressbar"
                        aria-valuenow="30"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style="width: 100%"
                      >
                        <span class="sr-only">30%</span>
                      </div>
                    </div>
                    <div
                      class="sameRight d-flex align-items-center justify-content-end"
                    >
                      <div class="volume equal">
                        <p class="mb-0">{{ value }}</p>
                      </div>
                      <div class="maxVolume equal">
                        <p class="mb-0">{{ key }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="steps mt-5 text-center">
                <a
                  href="javascript:void(0)"
                  class="cap_btn min-250"
                  @click="taskTab = ''"
                  >Done</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import tradingMixins from "@/plugins/trading";
import depositWithdrawalMixins from "@/plugins/depositWithdrawal";
import { Const } from "@/plugins/vue-provider-cache/const.mod";
import math from "../../../../static/website/js/math.js";
import currencyChart from "../shared/chart/currencyChart";
import moment from "moment";

export default {
  name: "index",
  mixins: [tradingMixins, depositWithdrawalMixins],
  data() {
    return {
      taskTab: "",
      step: 1,
      gauth: "",
      pageLoader: false,
      internalTransferResponse: {},
      notification_msg: "",
      notification_type: "",
      exchangeTypeS: {
        M: "Market",
        S: "Stop",
        L: "Limit",
        SL: "Stop Limit",
      },
      type: "2",
      currency: "",
      freeMargin: 0,
      free_Margin: 0,
      tab: "deposit",
      searchcrypto: "",
      errImage: [],
      fev_list: [],
      margin_list: {}, // currency with ammount available in account
      margin_list_social: {}, // currency with ammount available in account
      amount: {},
      agree: false,
      error: null,
      data_value: {},
      curencyUsdValList: [],
      currencies: false,
      accountsList: [],
    };
  },
  watch: {
    taskTab(value) {
      this.step = 1;
      this.gauth = "";
      this.error = null;
      if (value == "TopUp") {
        this.getAccountInfo("primary");
      } else {
        this.getAccountInfo("social");
      }
    },
    socialAccount(value) {
      this.allListing(value, true);
      this.getAccountMarginInfo(value, true);
      // if (this.taskTab == "TopUp") {
      //   this.getAccountDeposits(value);
      // } else {
      //   this.getAccountWithdrawals(value);
      // }
    },
    tradingAccount(value) {
      this.allListing(value);
      this.getAccountMarginInfo(value);
      // if (this.taskTab == "TopUp") {
      //   this.getAccountDeposits(value);
      // } else {
      //   this.getAccountWithdrawals(value);
      // }
    },
    margin_list(value) {
      if (Object.keys(value).length) {
        let counter = 0;
        for (let key in value) {
          if (counter == 0) {
            this.data_value[value[key].currency] = "20";
            this.amount[value[key].currency] = value[key].freemargin / 5;
          } else {
            this.data_value[value[key].currency] = "0";
            this.amount[value[key].currency] = 0;
          }
          counter++;
        }
      }
    },
    step(value) {
      this.gauth = "";
      this.error = null;
    },
    margin_list_social(value) {
      if (Object.keys(value).length) {
        let counter = 0;
        for (let key in value) {
          if (counter == 0) {
            this.data_value[value[key].currency] = "20";
            this.amount[value[key].currency] = value[key].freemargin / 5;
          } else {
            this.data_value[value[key].currency] = "0";
            this.amount[value[key].currency] = 0;
          }
          counter++;
        }
      }
    },
  },
  components: {
    currencyChart,
  },
  computed: {
    accountsWithMargin() {
      let arr = [];
      if (this.taskTab == "TopUp") {
        if (this.tradingAccount.length) {
          for (let account of this.tradingAccount[0].subAccounts) {
            if (
              this.margin_list[account.act_account_id] &&
              this.margin_list[account.act_account_id].freemargin
            )
              arr.push(account);
          }
        }
      } else {
        if (this.socialAccount.length) {
          for (let account of this.socialAccount[0].subAccounts) {
            if (
              this.margin_list[account.act_account_id] &&
              this.margin_list[account.act_account_id].freemargin
            )
              arr.push(account);
          }
        }
      }
      return arr;
    },
    instruments() {
      try {
        this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
        return this.$store.getters[Const.GET_PROVIDERS][
          "priceFeed"
        ].iCache.asKeysValueArrayAll();
      } catch (ex) {
        return [];
      }
    },
    totalUsdValue() {
      try {
        let amount = 0;
        for (const item in this.marginInfoListSocial) {
          amount += parseFloat(
            this.getConvertedValue(this.marginInfoListSocial[item], "USD")
          );
        }
        return amount.toFixed(3);
      } catch (e) {
        return "N/A";
      }
    },
    totalBtcValue() {
      try {
        let amount = 0;
        for (const item in this.marginInfoListSocial) {
          amount += parseFloat(
            this.getConvertedValue(this.marginInfoListSocial[item], "BTC")
          );
        }
        return this.formatfloat(amount.toFixed(8));
      } catch (e) {
        return "N/A";
      }
    },
    leftValComputed() {
      let obj = {};
      for (let key in this.margin_list) {
        let newValue = this.data_value[this.margin_list[key].currency];
        let newPosition = 10 - newValue * 0.2;
        obj[
          this.margin_list[key].currency
        ] = `calc(${newValue}% + (${newPosition}px))`;
      }
      return obj;
    },
    validAmounts() {
      let obj = {};
      for (let key in this.amount) {
        if (this.amount[key] > 0) {
          obj[key] = this.amount[key];
        }
      }
      return obj;
    },
    errorWallets() {
      try {
        let obj = {};
        if (
          this.internalTransferResponse.transfer &&
          Object.keys(this.internalTransferResponse.transfer).length
        ) {
          for (let key in this.internalTransferResponse.transfer) {
            if (this.internalTransferResponse.transfer[key].error == 1) {
              obj[key] = this.internalTransferResponse.transfer[key];
            }
          }
        }
        return obj;
      } catch (error) {
        return {};
      }
    },
  },
  methods: {
    changeCurencyUsdValList() {
      this.currencyData();
      setInterval(() => {
        this.currencyData();
      }, 5000);
    },
    currencyData() {
      try {
        for (let item in this.marginInfoListSocial) {
          let index = this.curencyUsdValList
            .map((e) => e.currency)
            .indexOf(this.marginInfoListSocial[item].currency);
          if (index == -1) {
            this.curencyUsdValList.push({
              currency: this.marginInfoListSocial[item].currency,
              usdValue: this.getConvertedValue(
                this.marginInfoListSocial[item],
                "USD"
              ),
            });
          } else {
            this.curencyUsdValList[index]["usdValue"] = this.getConvertedValue(
              this.marginInfoListSocial[item],
              "USD"
            );
          }
        }
        this.curencyUsdValList.sort(function (a, b) {
          return parseFloat(b.usdValue) - parseFloat(a.usdValue);
        });
      } catch (e) {
        setTimeout(() => {
          this.currencyData();
        }, 1000);
      }
    },
    fromDate(val) {
      return moment(val).fromNow();
    },
    getConvertedValue(item, currency) {
      if (item.currency == currency) {
        return item.amount;
      } else {
        let amount = 0;
        if (this.instruments[item.currency + "-" + currency]) {
          amount = this.instruments[item.currency + "-" + currency].A;
        } else if (this.instruments[currency + "-" + item.currency]) {
          return 1 / this.instruments[currency + "-" + item.currency].A;
        } else {
          let basePrice = null,
            reversebasePrice = null,
            pairValue = null,
            revpairValue = null;
          if (currency == "USD") {
            basePrice = this.instruments[item.currency + "-BTC"];
            reversebasePrice = this.instruments["BTC-" + item.currency];
            pairValue = this.instruments["BTC-" + currency];
          } else {
            basePrice = this.instruments[item.currency + "-USD"];
            reversebasePrice = this.instruments["USD-" + item.currency];
            pairValue = this.instruments["USD-" + currency];
          }
          if (basePrice && pairValue) {
            amount = pairValue.A * basePrice.A;
          } else if (reversebasePrice && pairValue) {
            amount = pairValue.A / reversebasePrice.A;
          } else {
            amount = 0;
          }
        }
        if (currency == "USD") {
          return (amount * item.amount).toFixed(3);
          // return (amount * item.amount).toFixed(3)
        } else {
          return this.formatfloat(amount * item.amount);
        }
      }
    },
    formatfloat(num) {
      if (num) {
        num = parseFloat(num);
        try {
          return math.format(num, { notation: "fixed" }) || "";
        } catch (e) {
          try {
            return num.toFixed(8);
          } catch (e) {
            return "";
          }
        }
      } else {
        return 0;
      }
    },
    redirect() {
      this.$router.replace({
        name: "support",
        params: { tabName: "openRequest", page: "view_dash" },
      });
    },
    parseFloatVal(val) {
      return parseFloat(val).toFixed(8);
    },
    isImage(img) {
      return this.errImage.includes(img) ? false : true;
    },
    handleImgErr(val) {
      var fullSrc = val.target.src.split(".");
      var src = fullSrc[fullSrc.length - 2].split("/");
      var img = src[src.length - 1];
      if (!this.errImage.includes(img)) {
        this.errImage.push(img);
      }
    },
    createClass(index) {
      index++;
      return "p" + index + " col" + index;
    },
    subscribe(subscribeArray) {
      try {
        this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
          "S_PF_PF"
        ].subscribe(subscribeArray);
      } catch (e) {}
    },
    currencyListFunc() {
      try {
        if (this.searchcrypto == "") {
          return this.socialAccount[0].subAccounts;
        } else {
          return this.socialAccount[0].subAccounts.filter((val) =>
            val.currency.toLowerCase().includes(this.searchcrypto.toLowerCase())
          );
        }
      } catch (e) {
        return [];
      }
    },
    orderData(type) {
      if (type == "1") {
        return this.orderListSocial.records.filter(
          (val) => val.Status == "CREATED"
        );
      } else if (type == "2") {
        return this.orderListSocial.records.filter(
          (val) => val.Status == "FILLED"
        );
      } else if (type == "3") {
        return this.orderListSocial.records.filter(
          (val) => val.Status == "CANCELED"
        );
      } else {
        return [];
      }
    },
    getCurrency(value) {
      if (value.length > 0 && value[0].subAccounts.length > 0) {
        this.currency = value[0].subAccounts[0];
        let btcPair = value[0].subAccounts.map((val) => val.currency + "-BTC");
        let usdPair = value[0].subAccounts.map((val) => val.currency + "-USD");
        this.subscribPairs(btcPair.concat(usdPair));
        // this._runGetMarginInfo({
        //   globalParams: {
        //     account_id: value.length ? `${value[0].account_id}` : `0`,
        //   },
        //   localParams: { parameter: this, page: "home" },
        // });
      }
    },
    subscribPairs(pairList) {
      try {
        if (pairList.length > 0) {
          this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
            "S_PF_PF"
          ].subscribe(pairList);
        }
      } catch (e) {
        setTimeout(() => {
          this.subscribPairs(pairList);
        }, 1000);
      }
    },
    setProgressBar(val, wallet) {
      let newObj = { ...this.data_value, [wallet.currency]: val };
      this.data_value = Object.assign({}, newObj);
      let freemargin = this.margin_list[wallet.act_account_id].freemargin;
      let newAmount = {
        ...this.amount,
        [wallet.currency]: freemargin * (val / 100),
      };
      this.amount = Object.assign({}, newAmount);
    },
    setAmount(val, wallet) {
      let newObj = { ...this.amount, [wallet.currency]: val };
      this.amount = Object.assign({}, newObj);
      let freemargin = this.margin_list[wallet.act_account_id].freemargin;
      let newDataValue = {
        ...this.data_value,
        [wallet.currency]: ((val / freemargin) * 100).toFixed(2),
      };
      this.data_value = Object.assign({}, newDataValue);
    },
    confirmStep() {
      this.error = null;
      if (this.step == 1) {
        if (!this.agree) this.error = "Please check above box to proceed";
        if (Object.keys(this.validAmounts).length == 0)
          this.error = "Add funds from atleast 1 wallet to transfer";
        if (this.error) return;
        this.step++;
      } else if (this.step == 2) {
        if (this.gauth == "") this.error = "Please enter gauth code";
        if (Object.keys(this.validAmounts).length == 0)
          this.error = "Add funds from atleast 1 wallet to transfer";
        if (this.error) return;
        this.internalTransferVerify();
      } else if (this.step == 3) {
        this.step = 1;
      }
    },
    internalTransferVerify() {
      let accountsObj = {};
      for (let key in this.margin_list) {
        if (this.validAmounts[this.margin_list[key].currency]) {
          accountsObj[key] = {
            id: key,
            currency: this.margin_list[key].currency,
            amount: this.validAmounts[this.margin_list[key].currency],
          };
        }
      }
      let obj = {
        globalParams: {
          account_id:
            this.taskTab == "TopUp"
              ? `${this.tradingAccount[0].account_id}`
              : `${this.socialAccount[0].account_id}`,
          to_account_id:
            this.taskTab == "Withdraw"
              ? `${this.tradingAccount[0].account_id}`
              : `${this.socialAccount[0].account_id}`,
          operation: "TRANSFER",
          otp: this.gauth,
          transfer: accountsObj,
          topup: true,
        },
        localParams: {
          parameter: this,
        },
      };
      this._runInternalTransferVerify(obj);
    },
    allListing(value, isSocial) {
      this.getCurrency(value);
      if (isSocial && value.length > 0) {
        let jsonData = {
          globalParams: {
            account_id: value[0].account_id,
            demo_live: value[0].demo_live,
            is_social: 1,
          },
          localParams: { parameter: this },
        };
        this._runGetOrderList(jsonData);
        let dData = {
          globalParams: {
            filter: {
              "deposit.account_id": value.length
                ? `${value[0].account_id}`
                : "0",
            },
            sort: [],
            search: "",
            page: "1",
            perPage: 4,
          },
          localParams: { parameter: this },
        };
        this._runGetDepsitList(dData);
        let wData = {
          globalParams: {
            filter: {
              "withdrawal.account_id": value.length
                ? `${value[0].account_id}`
                : "0",
            },
            sort: [],
            search: "",
            page: "1",
            perPage: 4,
          },
          localParams: { parameter: this },
        };

        this._runGetWithdrawalList(wData);
      }

      setTimeout(() => {
        this.subscribe([
          "BTC-USD",
          "ETH-USD",
          "LTC-USD",
          "BCH-USDT",
          "ADA-USD",
          "EOS-USD",
        ]);
      }, 2000);
      this._runGetMarginInfo({
        globalParams: {
          account_id: value.length ? `${value[0].account_id}` : "0",
        },
        localParams: { parameter: this, page: "home" },
      });
    },
    getAccountInfo(type) {
      if (type == "primary") {
        this._runTradingAccount({
          globalParams: {},
          localParams: {
            parameter: this,
          },
        });
      } else {
        this._runTradingAccount({
          globalParams: {
            is_social: 1,
          },
          localParams: {
            parameter: this,
          },
        });
      }
    },
    getAccountMarginInfo(accounts, is_social) {
      if (is_social) {
        this._runGetMarginInfo({
          globalParams: {
            account_id: accounts.length ? `${accounts[0].account_id}` : "0",
            is_social: 1,
          },
          localParams: { parameter: this, page: "home" },
        });
      } else {
        this._runGetMarginInfo({
          globalParams: {
            account_id: accounts.length ? `${accounts[0].account_id}` : "0",
          },
          localParams: { parameter: this, page: "home" },
        });
      }
    },
    getAccountDeposits(accounts) {
      if (this.socialAccount.length) {
        let data = {
          globalParams: {
            filters: {
              "deposit.account_id": `${this.socialAccount[0].account_id}`,
            },
            sort: [],
            search: "",
            page: "1",
            perPage: 4,
          },
          localParams: { parameter: this },
        };
        this._runGetDepsitList(data);
      } else {
      }
    },
    getAccountWithdrawals(accounts) {
      if (this.socialAccount.length) {
        let data = {
          globalParams: {
            filters: {
              "withdrawal.account_id": `${this.socialAccount[0].account_id}`,
            },
            sort: [],
            search: "",
            page: "1",
            perPage: 4,
          },
          localParams: { parameter: this },
        };
        this._runGetWithdrawalList(data);
      } else {
        this.getAccountInfo("social");
      }
    },
  },
  created() {
    // if(!this.tradingAccount.length) {
    //   this._runTradingAccount({
    //     globalParams: {},
    //     localParams: {
    //       parameter: this,
    //     },
    //   });
    // } else {
    // }
    if (!this.socialAccount.length) {
      this._runTradingAccount({
        globalParams: {
          is_social: 1,
        },
        localParams: {
          parameter: this,
        },
      });
    } else {
      this._runGetMarginInfo({
        globalParams: {
          account_id: this.socialAccount.length
            ? `${this.socialAccount[0].account_id}`
            : `0`,
          is_social: 1,
        },
        localParams: { parameter: this, page: "home" },
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/social-trading/social_profile.vue